import React from "react";
import { NEWSLETTER_META } from "@/data/newsletterIssues";

// Permanent legal disclaimer — mandatory in the footer of the hub, archive, every issue, and PDFs.
// Not hidden. Readable typography.
export function PermanentDisclaimer({ className = "", testid = "newsletter-permanent-disclaimer" }) {
  return (
    <aside
      data-testid={testid}
      className={`border-t border-white/10 bg-[#0A1020] ${className}`}
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-12 py-8 sm:py-10">
        <div className="text-[10px] uppercase tracking-[0.28em] text-[#D4AF37] font-bold mb-3">
          Disclaimer
        </div>
        <p className="text-slate-300 text-sm sm:text-[15px] leading-relaxed">
          {NEWSLETTER_META.permanentDisclaimer}
        </p>
      </div>
    </aside>
  );
}

// Separate Amazon Associates affiliate disclosure — appears near affiliate CTAs.
export function AffiliateDisclosure({ className = "", testid = "newsletter-affiliate-disclosure" }) {
  return (
    <p
      data-testid={testid}
      className={`text-[10px] uppercase tracking-[0.22em] text-slate-500 leading-relaxed ${className}`}
    >
      {NEWSLETTER_META.affiliateDisclosure}
    </p>
  );
}
